import React from "react";
import { Icon } from "@chakra-ui/react";

export const TagCloseIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.6663 4.27334L11.7263 3.33334L7.99967 7.06001L4.27301 3.33334L3.33301 4.27334L7.05967 8.00001L3.33301 11.7267L4.27301 12.6667L7.99967 8.94001L11.7263 12.6667L12.6663 11.7267L8.93967 8.00001L12.6663 4.27334Z"
        fill="#1A1A1A"
      />
    </Icon>
  );
};
